import React, { Component } from 'react';
import autoBind from 'react-autobind';
import { connect } from 'react-redux';
import { injectIntl, defineMessages } from 'react-intl';
import { push } from 'react-router-redux';

import { selectUserSkills } from 'store/features/users/skills/selectors';

import ProfileSection from 'ui/users/profile-section';
import Grid from './grid';
import { TabHeader, TabItem, TabLink } from 'ui/common/tabs';

const messages = defineMessages({
  title: {
    id: 'users.skills.title',
    defaultMessage: 'Skills Overview',
    currentTab: false, // false means all skills
  },
  allSkills: {
    id: 'users.skills.category.type.all-skills',
    defaultMessage: 'All Skills',
  },
});

class UserSkillsSection extends Component {
  constructor(props) {
    super(props);
    autoBind(this);

    this.state = {
      activeTab: 'allSkills',
    };
  }

  onToggle(tab) {
    this.setState({
      activeTab: tab,
    });
  }

  renderTabHeader() {
    const { skillCategoryNames, intl: { formatMessage } } = this.props;

    if (!skillCategoryNames && skillCategoryNames.length === 0) return null;

    return (
      <div>
        <TabHeader>
          <TabItem>
            <TabLink
              onClick={() => this.onToggle('allSkills')}
              active={this.state.activeTab === 'allSkills'}
            >
              {formatMessage(messages.allSkills)}
            </TabLink>
          </TabItem>
          {skillCategoryNames.map((skillCategoryName, index) => {
            return (
              <TabItem key={index}>
                <TabLink
                  onClick={() => this.onToggle(skillCategoryName)}
                  active={
                    this.state.activeTab.toString().toLowerCase() ===
                    skillCategoryName.toString().toLowerCase()
                  }
                >
                  {skillCategoryName}
                </TabLink>
              </TabItem>
            );
          })}
        </TabHeader>
      </div>
    );
  }

  render() {
    const { canManage, intl: { formatMessage }, entries } = this.props;
    const { activeTab } = this.state;

    if (!canManage && (!entries || entries.length === 0)) return null;

    let finalUserSkills = [];

    if (activeTab === 'allSkills') {
      finalUserSkills = entries;
    } else {
      finalUserSkills = entries.filter(entry => entry.skill.category.name === activeTab);
    }

    return (
      <div className="row" id="skills">
        <ProfileSection title={formatMessage(messages.title)} collapsible className="col-12 py-1">
          <div className="row pb-3">
            <div className="col-12">{this.renderTabHeader()}</div>
          </div>

          <div className="row">
            <div className="col-12">
              <Grid
                entries={finalUserSkills}
                showAddButton={canManage}
                canManage={canManage}
                onEntryClick={this.onEntryClick}
                isHighlighted={false}
              />
            </div>
          </div>
        </ProfileSection>
      </div>
    );
  }
}

function mapStateToProps(state, ownProps) {
  let { userId } = ownProps;

  const entries = selectUserSkills(state, { userId });

  let skillCategoryNames = entries
    .filter((entry, index, selfEntries) => {
      // remove duplicate skillCategoryName
      return (
        index ===
        selfEntries.findIndex(selfEntry => {
          return entry.skill.category.name === selfEntry.skill.category.name;
        })
      );
    })
    .map(entry => {
      // return the value name after filter
      return entry.skill.category.name;
    });

  return { entries, skillCategoryNames };
}

const mapDispatchToProps = { push };

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(UserSkillsSection));
